import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { BaseApiService } from './base-api.service';
import { LiveCamera } from './../models/live-camera.model';
import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';

@Injectable()
export class LiveCameraService extends BaseApiService implements Resolve<LiveCamera[]> {

  constructor(private apiCallService: ApiCallService) {
    super();
   }

  getLiveCameras(): Promise<LiveCamera[]> {
    return this.apiCallService.get('/cameras');
  }

  getLiveCamera(id: number): Promise<LiveCamera> {
    this.validateId(id, 'id');
    return this.apiCallService.get('/cameras/' + id);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const id = route.params['friendly_id'];
    let promise;
    if (id === undefined) {
      promise = this.getLiveCameras();
    } else {
      promise = this.getLiveCamera(id);
    }

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/live-camera.service.ts